import { graphql, useStaticQuery } from 'gatsby'

const allContentfulNavMenu = () => {
  return useStaticQuery(graphql`
    {
      allContentfulNavMenu(
        filter: {
          location: {
            in: [
              "Header"
              "French Header"
              "German Header"
              "Japanese Header"
              "Portuguese Header"
              "Korean Header"
              "Spanish Header"
              "Chinese Header"
              "New Header"
              "New French Header"
              "New German Header"
              "New Spanish Header"
              "New Japanese Header"
              "New Korean Header"
              "New Portuguese Header"
              "New Chinese Header"
              "New Header Testing"
              "V3 Header French"
              "V3 Header German"
              "V3 Header Japanese"
              "V3 Header Portuguese"
              "V3 Header Korean"
              "V3 Header Chinese"
              "V3 Header Trad Chinese"
            ]
          }
        }
      ) {
        nodes {
          __typename
          name
          location
          entryLocale
          node_locale
          primaryCta {
            ...topicCTA
          }
          topHatLinks {
            ... on Node {
              ...topicCTA
              ...iconLink
            }
          }
          menuGroups {
            ... on ContentfulMenuGroup {
              __typename
              id
              newGroupName
              groupStyle
              groupNameColor
              menuGroupDescription
              greyColumns
              greyColumnAlignment
              menuStyle
              highlightedLinks {
                ...topicCTA
              }
              bottomText
              bottomTextCta {
                ...topicCTA
              }
              parentLink {
                ...topicCTA
              }
              pages {
                ... on Node {
                  ...topicCTA
                  ...menuGroups
                  ...iconLink
                }
              }
            }
          }
        }
      }
    }
    fragment menuGroups on ContentfulMenuGroup {
      __typename
      id
      groupStyle
      newGroupName
      groupNameColor
      menuGroupDescription
      greyColumns
      greyColumnAlignment
      menuStyle
      highlightedLinks {
        ...topicCTA
      }
      bottomText
      bottomTextCta {
        ...topicCTA
      }
      parentLink {
        ...topicCTA
      }
      pages {
        ... on Node {
          ...topicCTA
          ...iconLink
          ... on ContentfulMenuGroup {
            __typename
            id
            groupStyle
            newGroupName
            groupNameColor
            menuGroupDescription
            menuStyle
            highlightedLinks {
              ...topicCTA
            }
            bottomText
            bottomTextCta {
              ...topicCTA
            }
            parentLink {
              ...topicCTA
            }
            pages {
              ...topicCTA
              ...iconLink
            }
          }
        }
      }
    }
    fragment iconLink on ContentfulTopicIconLink {
      __typename
      id
      name
      icon {
        altText
        image {
          file {
            url
          }
        }
      }
      ctaText
      url
      description
      highlightText
    }
    fragment topicCTA on ContentfulTopicCta {
      __typename
      id
      externalUrl
      text
      description
      internalLink {
        ... on Node {
          ... on ContentfulPageAboutRpa {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageBlogPost {
            __typename
            id
            name
            slug
            blogCategory {
              seoMetadata {
                pageCanonicalUrl
              }
            }
          }
          ... on ContentfulPageCompanyListing {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageDownload {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageFlex {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageLegal {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageMainBlog {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageNewsroomArticle {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPagePartner {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPagePlaceholder {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageProduct {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageResource {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageResourceDemo {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageResourceListing {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulPageSolutions {
            __typename
            id
            name
            slug
          }
          ... on ContentfulPageWhitePaper {
            __typename
            contentful_id
            id
            name
            slug
          }
          ... on ContentfulTopicAnchorLink {
            __typename
            contentful_id
            name
            identifier
          }
          ... on ContentfulWrapperPdf {
            __typename
            id
            name
            slug
          }
        }
      }
    }
    fragment internalLink on ContentfulTopicInternalLink {
      __typename
      id
      ctaText
      internalLink {
        ... on Node {
          ... on ContentfulHomepage {
            __typename
            slug
            id
            name
          }
          ... on ContentfulPageAboutRpa {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageAnalystReport {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageBlogPost {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageCompanyListing {
            __typename
            slug
            id
            name
          }
          ... on ContentfulPageDownload {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageFlex {
            __typename
            slug
            id
            name
          }
          ... on ContentfulPageLegal {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageMainBlog {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageNewsroomArticle {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPagePartner {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageProduct {
            __typename
            slug
            id
            name
          }
          ... on ContentfulPageResourceDemo {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageResourceListing {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageSolutions {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageWebinarRecording {
            __typename
            slug
            id
            name
            pageName
          }
          ... on ContentfulPageWhitePaper {
            __typename
            slug
            id
            name
            pageName
          }
        }
      }
    }
  `)
}

export default { allContentfulNavMenu }
